import React from "react";
import { EditableTable, createQuickRenderer } from "../../common";
import { useKycShareholderTable, type IKycShareholderTableProps } from "./useKycShareholderTable";

export const KycShareholderTable: React.FC<IKycShareholderTableProps> = props => {
  const { shareholders, shareholderColumns, crossIntl, handleChange } = useKycShareholderTable(
    props,
    createQuickRenderer,
  );

  return (
    <EditableTable
      value={shareholders}
      onChange={handleChange}
      columns={shareholderColumns}
      title={crossIntl["shareholder.table.title"]}
      addButtonText={crossIntl["shareholder.button.add"]}
      minRows={2}
    />
  );
};
